function UserPermission() {
    "use strict";
    this.__type = 'UserPermission:www.veritracks.com';
    this.Id = -1;
    this.PermissionId = -1;
    this.Version = 0;
    this.UserId = -1;
    this.LoginUserId = -1;
    this.Value = 0;
    this.TransactionId = '';
}
if (typeof exports !== 'undefined') {
    module.exports = UserPermission;
}